import React from 'react';

export default function Feature({ iconSrc, title, subTitle }) {
  return (
    <div
      className='cs_feature cs_style_1 cs_shadow_1 cs_radius_25 cs_white_bg d-flex flex-column h-100'
      style={{
        minHeight: '280px',
      }}
    >
      <style jsx>{`
        .cs_feature.cs_style_1:hover .cs_feature_title::before {
          opacity: 0 !important;
          transform: translate(-50%, -50%) scale(0.5) !important;
        }
      `}</style>
      <h2 className='cs_feature_title cs_semibold cs_fs_40 text-center mb-3 d-flex align-items-center justify-content-center'>
        <span className='cs_feature_icon cs_accent_bg cs_center rounded-circle '>
          <img src={iconSrc} alt='Icon' />
        </span>
        <span>{title}</span>
      </h2>
      <p className='m-0 text-center flex-grow-1'>{subTitle}</p>
    </div>
  );
}
